export default "__VITE_ASSET__wASpRrmn__"